"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubMenu = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const unstyled_list_1 = require("../lists/unstyled-list");
exports.SubMenu = (0, styled_components_1.default)(unstyled_list_1.BareUl) `
  position: absolute;
  display: block;
  left: 100%;
  top: 0;

  background: linear-gradient(to bottom, #eef0ec, #fcfcfc 80%);

  box-shadow: 5px 5px 5px #000;

  border: 1px solid #000;

  padding: 3px 0;

  li {
    white-space: nowrap;

    font-weight: 100;
    color: black;

    &:hover {
      cursor: pointer;
      background: linear-gradient(to top, rgb(84, 192, 242), rgb(0, 168, 235));
      color: white;
    }
  }
`;
//# sourceMappingURL=sub-menu.js.map